import React from 'react'
import logoImage from '../images/tao2.png'

const logo = (props) => (
  <div className='Logo'>
    <img src={logoImage} alt="JMScott" />
  </div>
)

export default logo